/**
 * Portal Supabase Client
 * Points to the ESR ELECTRIC CRM backend so the client portal
 * reads from the same database as the CRM.
 */
import { createClient } from '@supabase/supabase-js';

const PORTAL_SUPABASE_URL = "https://ptnmirtqzpxhgrsddvlv.supabase.co";
const PORTAL_SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0bm1pcnRxenB4aGdyc2Rkdmx2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk1NTYwODAsImV4cCI6MjA4NTEzMjA4MH0.l6Ft-J8od6FVxbd8JR_99vZa5Qe_xc0MQghqHRiO7Gs";

export const supabase = createClient(PORTAL_SUPABASE_URL, PORTAL_SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
